module.exports = __webpack_public_path__ + "img/powerpoint-slide-design.b9eb5b7.svg";